module.exports = __webpack_public_path__ + "static/media/InfoCircle.0f3145a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/InfoCircle.svg
// module id = 1218
// module chunks = 0